import { dateFormat } from "@/utils/helpers";
import axios from "axios";
import { ToastServiceMethods } from "primevue/toastservice";
import { ref } from "vue";

export const useNyhForm = (toast: ToastServiceMethods) => {
  const dte = ref(new Date());
  const results = ref("");

  const dteInvalid = ref(false);
  const resultsInvalid = ref(false);
  const loading = ref(false);

  const stringToNumbers = (str: string) => {
    return str ? str.split(",").map((e) => Number(e)) : [];
  };

  return {
    dte,
    results,
    dteInvalid,
    resultsInvalid,
    loading,
    onSubmit: async (API_URL: string) => {
      loading.value = true;

      // Validation
      let valid = true;
      if (dte.value) {
        dteInvalid.value = false;
      } else {
        dteInvalid.value = true;
        toast.add({ severity: "warn", summary: "Error", detail: "Date is Required", life: 10000 });
        valid = false;
      }

      let numbers: (string | number)[] = [];
      if (results.value !== "*") {
        numbers = stringToNumbers(results.value ?? "");
        if (numbers.length >= 1 && numbers.length <= 4 && numbers.every((e) => !Number.isNaN(e))) {
          resultsInvalid.value = false;
        } else {
          resultsInvalid.value = true;
          results.value
            ? numbers.length >= 1 && numbers.length <= 4
              ? toast.add({ severity: "warn", summary: "Warning", detail: "Not All items are numbers", life: 10000 })
              : toast.add({ severity: "warn", summary: "Warning", detail: "Entry 1 or 4 numbers", life: 10000 })
            : toast.add({ severity: "warn", summary: "Warning", detail: "Numbers are Required", life: 10000 });

          valid = false;
        }
      }

      if (valid) {
        const url = `${API_URL}/results`;

        const response = await axios.post<{ success: boolean; msg?: string }>(url, {
          lottery_id: 28,
          dte: dateFormat(dte.value, "yyyy-LL-dd"),
          tod: "EVENING",
          name: "Numbers",
          numbers,
        });

        if (response.data.success) {
          dte.value = new Date();
          results.value = "";
          toast.add({ severity: "success", summary: "Success", detail: "Results added", life: 10000 });
        } else {
          toast.add({ severity: "error", summary: "Error", detail: response.data.msg, life: 10000 });
        }
      }

      loading.value = false;
    },
  };
};
